<template>
  <!-- 大件称重记录 -->
  <div class="Box">
    <el-form label-position="top" class="selectClass">
      <el-row type="flex" justify="start" style="flex-wrap: wrap;">
        <el-col :span="6">
          <el-form-item>
            <template slot="label">
              <el-select
                v-model="chooseNumber"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                size="small"
                @change="changeNum"
                class="orderNumClass"
              >
                <el-option key="1" :label="$t('orderCenterCont.anjunWaybillNumber')" :value="1" /><!-- 安骏运单号 -->
                <el-option key="2" :label="$t('navbar.anjunOrderNumber')" :value="2" /><!-- 安骏订单号 -->
              </el-select>
            </template>
            <el-input
              v-model="orderNumber"
              :placeholder="$t('collectionCenter.max2000Line')"
              clearable
              type="textarea"
              @blur="ft"
              @keydown.enter.native="BlockNewNumberline"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <!--客户名称-->
          <el-form-item :label="$t('collectionCenter.CustomerN')">
            <el-select
              v-model="queryForm.params.customerId"
              :placeholder="$t('GlobalSetObj.Only10AreDisplayed')"
              style="width: 100%;"
              filterable
              clearable
              remote
              reserve-keyword
              :remote-method="getCustomerOption"
              @clear="getCustomerOption('')"
            >
              <el-option
                v-for="item in customerOption"
                :key="item.id"
                :label="item.customerAlias + '（' + item.username + '）'"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <!--操作网点-->
          <el-form-item :label="$t('collectionCenter.OperationSite')">
            <el-select
              v-model="queryForm.params.siteId"
              :placeholder="$t('GlobalSetObj.Only10AreDisplayed')"
              clearable
              filterable
              style="width: 100%"
              remote
              reserve-keyword
              :remote-method="remoteGetSiteList"
              @clear="remoteGetSiteList"
            >
              <el-option
                v-for="item in siteList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <!--操作人-->
          <el-form-item :label="$t('collectionCenter.operator')">
            <el-select
              v-model="queryForm.params.operatorUser"
              :placeholder="$t('GlobalSetObj.Only10AreDisplayed')"
              clearable
              filterable
              remote
              reserve-keyword
              :remote-method="getOperator"
              @clear="getOperator"
              style="width: 100%;"
            >
              <el-option
                v-for="(item, index) in operatorList"
                :key="index"
                :label="item.realName + '（' + item.username + '）'"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <!--操作时间-->
          <el-form-item :label="$t('basicData.OperationTime')">
            <el-date-picker
              v-model="timeValue"
              :clearable="true"
              :default-time="['00:00:00', '23:59:59']"
              :end-placeholder="$t('collectionCenter.EndTime')"
              :range-separator="$t('collectionCenter.to')"
              :start-placeholder="$t('collectionCenter.StartTime')"
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm:ss"
              @change="dateChange"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <div style="margin: 30px auto; text-align: center">
            <el-button size="mini" type="primary" @click="searchClick">
              {{ $t('operationCenter.Procurar') }}
            </el-button><!-- 搜索 -->
            <el-button size="mini" type="info" @click="resetClick">
              {{ $t('collectionCenter.reset') }}
            </el-button><!-- 重置 -->
          </div>
        </el-col>
      </el-row>
    </el-form>
    <el-divider />
    <div style="margin-bottom: 20px;">
      <el-button
        size="mini"
        type="success"
        @click="chooseDownload"
      >{{ $t('collectionCenter.export1') }}</el-button><!-- 勾选导出 -->
      <el-button
        size="mini"
        type="success"
        @click="downloadAll"
      >{{ $t('collectionCenter.allExport') }}</el-button><!-- 全部导出 -->
    </div>

    <el-table
      ref="tableRef"
      :data="tableDate"
      :max-height="600"
      border
      @select="batchSelect"
      @select-all="batchSelect"
    >
      <el-table-column
        type="selection"
        width="55"
      />
      <!-- 序号 -->
      <el-table-column
        :label="$t('collectionCenter.ind')" align="center" type="index"
        width="60"
      >
        <template slot-scope="scope">
          <span>{{ (queryForm.pageNumber - 1) * queryForm.pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('orderCenterCont.anjunWaybillNumber')"
        prop="waybillNumber"
        align="center"
      /><!-- 安骏运单号 -->
      <el-table-column
        :label="$t('collectionCenter.orderNumberWithTotal')"
        prop="orderNumber"
        align="center"
      ><!-- 安骏订单号（总件数） -->
        <template slot-scope="scope">
          <div>{{ scope.row.orderNumber }}（{{ scope.row.waybillCount }}）</div>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('orderCenterCont.CustomerName')"
        prop="customerName"
        align="center"
      /><!-- 客户名称 -->
      <el-table-column
        :label="$t('collectionCenter.transitWeight')"
        prop="transportWeight"
        align="center"
      /><!-- 中转称重(kg) -->
      <el-table-column
        :label="$t('collectionCenter.orderWeightKG')"
        prop="weight"
        align="center"
      /><!-- 下单重量(kg) -->
      <el-table-column
        prop="weightDifference"
        align="center"
      ><!-- 重量差异？ -->
        <template slot="header">
          <el-tooltip class="item" effect="dark" placement="top">
            <div slot="content" style="font-size: 14px;line-height: 20px;">
              {{ $t('collectionCenter.calculationRule') }}
              <!-- 计算规则:(中转称重-下单重量)/下单重量，百分比取绝对值 -->
              <br>
              {{ $t('collectionCenter.weightComparisonRule') }}
              <!-- 如果中转称重 > 下单重量，则使用符号↑，且大于等于3%则标记红色 -->
              <br>
              {{ $t('collectionCenter.weightComparisonRule2') }}
              <!-- 如果中转称重 < 下单重量，则使用符号↓ -->
            </div>
            <div>
              {{ $t('collectionCenter.weightDifference') }}<i class="el-icon-question" />
            </div>
          </el-tooltip>
        </template>
        <template slot-scope="scope">
          <div :style="scope.row.weightDifferenceColor ? 'color: red' : ''">
            {{ scope.row.weightDifference }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('collectionCenter.transitMeasurement')"
        prop="receiveVolumeWeight"
        align="center"
      /><!-- 中转测量体积(m³) -->
      <el-table-column
        :label="$t('collectionCenter.volumeWeight')"
        prop="volumeWeight"
        align="center"
      /><!-- 体积重(kg) -->
      <el-table-column
        :label="$t('collectionCenter.orderVolume')"
        prop="volume"
        align="center"
      /><!-- 下单体积(m³) -->
      <el-table-column
        :label="$t('collectionCenter.volumeDifference')"
        prop="volumeDifference"
        align="center"
      ><!-- 体积差异 -->
        <template slot="header">
          <el-tooltip class="item" effect="dark" placement="top">
            <div slot="content" style="font-size: 14px;line-height: 20px;">
              <!-- 计算规则:(中转测量体积下单体积)/下单体积，百分比取绝对值 -->
              {{ $t('collectionCenter.volumeCalculationRule') }}
              <br>
              <!-- 如果中转测量体积 > 下单体积，则使用符号↑，且大于等于3%则标记红色 -->
              {{ $t('collectionCenter.volumeComparisonWarning') }}
              <br>
              <!-- 如果中转测量体积 < 下单体积，则使用符号↓ -->
              {{ $t('collectionCenter.volumeDecreaseWarning') }}
            </div>
            <div>
              {{ $t('collectionCenter.volumeDifference') }}<i class="el-icon-question" />
            </div>
          </el-tooltip>
        </template>
        <template slot-scope="scope">
          <div :style="scope.row.volumeDifferenceColor ? 'color: red' : ''">
            {{ scope.row.volumeDifference }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('collectionCenter.controlsEmployee')"
        prop="operateUserName"
        align="center"
      /><!-- 操作员 -->
      <el-table-column
        :label="$t('collectionCenter.OperationSite')"
        prop="operateSiteName"
        align="center"
      /><!-- 操作网点 -->
      <el-table-column
        :label="$t('operationCenter.operationTime')"
        prop="operateTime"
        align="center"
      /><!-- 操作时间 -->
    </el-table>
    <div class="right">
      <el-pagination
        :current-page.sync="queryForm.pageNumber"
        :page-size.sync="queryForm.pageSize"
        :page-sizes="[10, 20, 50, 100, 500, 1000, 2000]"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        style="margin: 10px 0"
        @current-change="searchClick1"
        @size-change="searchClick"
      />
    </div>
  </div>
</template>

<script>
import {
  weightRecordPage,
  weightRecordExport,
  weightRecordAllExport
} from '@/api/bulkyExpress';
import { goRWExportList } from '@/utils/goExportList.js';
import {
  queryCustomerName
} from '@/api/bulkyExpress';
import { siteFuzzyQuery } from '@/api/lanshou';
import { getUserPage } from '@/api/user';
import dayjs from 'dayjs';
export default {
  name: 'LargeItemWeightRecord',
  data() {
    return {
      chooseNumber: 1,
      orderNumber: '',
      notEnter: true,
      customerOption: [],
      siteList: [],
      operatorList: [],
      timeValue: [],
      queryForm: {
        pageNumber: 1,
        pageSize: 10,
        params: {
          customerId: '',
          orderWaybillNumberList: [],
          orderNumberList: [],
          siteId: '',
          operatorUser: '',
          operatorBeginTime: '',
          operatorEndTime: ''
        }
      },
      total: 0,
      tableDate: [],
      exportList: []
    };
  },
  watch: {
    orderNumber(val) {
      let bgh = val.split('\n');
      // 过滤空项
      bgh = bgh.filter(function(f) {
        return f && f.trim();
      });
      // 去除空格
      const bghTrim = bgh.map(item => {
        return item.replace(/\s/g, '').trim();
      });
      let number = [];
      if (bghTrim.length >= 2000) {
        number = bghTrim.slice(0, 2000).join('\n');
        this.orderNumber = number;
        this.notEnter = false;
      } else {
        this.notEnter = true;
      }
      if (bghTrim.length > 1000) {
        this.$message.warning(this.$t('collectionCenter.searchMax1000')); // '单次查询最多2000条，已截取前2000条数据'
      }
    }
  },
  created() {
    this.default();
    this.getCustomerOption('');
    this.remoteGetSiteList('');
    this.getOperator('');
    this.searchClick();
  },
  methods: {
    changeNum() {
      this.orderNumber = '';
      this.queryForm.params.orderWaybillNumberList = [];
      this.queryForm.params.orderNumberList = [];
    },
    ft() {
      const val = this.orderNumber.split('\n');
      // 过滤空项
      const numLen = val.filter(function(f) {
        return f && f.trim();
      });
      // 去除空格
      const bghTrim = numLen.map(item => {
        return item.replace(/\s/g, '').trim();
      });
      this.orderNumber = bghTrim.join('\n');
      this.queryForm.params.orderWaybillNumberList = [];
      this.queryForm.params.orderNumberList = [];
      if (this.chooseNumber === 1) {
        this.queryForm.params.orderWaybillNumberList = bghTrim;
      }
      if (this.chooseNumber === 2) {
        this.queryForm.params.orderNumberList = bghTrim;
      }
    },
    BlockNewNumberline() { // 文本域最大输入行数为2000
      const e = window.event || arguments[0];
      this.ft();
      const numberLen = this.orderNumber.split('\n');
      if (!this.notEnter) {
        if (numberLen.length >= 2000) {
          this.$message.warning(this.$t('collectionCenter.PreciseSearch1')); // '精确搜索，一行一项，最多支持2000行'
        }
        e.returnValue = false;
        return true;
      }
    },
    // 获取客户选项
    getCustomerOption(name) {
      queryCustomerName(name).then(res => {
        if (res.code === 200) {
          this.customerOption = res.data;
        }
      });
    },
    // 获取操作网点数据
    remoteGetSiteList(val) {
      const value = val || '';
      siteFuzzyQuery(value).then((res) => {
        if (res.code === 200) {
          this.siteList = res.data;
        }
      });
    },
    // 获取操作人数据
    getOperator(name) {
      const queryForm = {
        pageSize: 10,
        pageNumber: 1,
        params: {
          realName: name
        }
      };
      getUserPage(queryForm).then(res => {
        if (res.code === 200) {
          this.operatorList = res.data.records;
        }
      }).catch(err => {
        console.error(err);
      });
    },

    dateChange(val) {
      if (val === null) {
        this.timeValue = [];
        this.queryForm.params.operatorBeginTime = '';
        this.queryForm.params.operatorEndTime = '';
        return;
      }
      this.queryForm.params.operatorBeginTime = val[0];
      this.queryForm.params.operatorEndTime = val[1];
    },
    default() {
      this.orderNumber = '';
      this.chooseNumber = 1;
      const d = new Date();
      const today = dayjs(d).format('YYYY-MM-DD');
      this.timeValue = [today + ' 00:00:00', today + ' 23:59:59'];
      this.queryForm.params = {
        customerId: '',
        orderWaybillNumberList: [],
        orderNumberList: [],
        siteId: '',
        operatorUser: '',
        operatorBeginTime: today + ' 00:00:00',
        operatorEndTime: today + ' 23:59:59'
      };
    },
    resetClick() {
      this.default();
      this.getCustomerOption('');
      this.remoteGetSiteList('');
      this.getOperator('');
      this.searchClick();
    },
    searchClick() {
      this.exportList = [];
      this.queryForm.pageNumber = 1;
      this.searchClick1();
    },
    searchClick1() {
      if (!this.orderNumber && !this.queryForm.params.operatorBeginTime && !this.queryForm.params.operatorEndTime) {
        this.$message.warning(this.$t('collectionCenter.PleaseSelectTime'));
        return;
      }
      if (this.chooseNumber === 1 && this.orderNumber) {
        this.queryForm.params.orderWaybillNumberList = this.orderNumber.split('\n');
        this.queryForm.params.orderNumberList = [];
      }
      if (this.chooseNumber === 2 && this.orderNumber) {
        this.queryForm.params.orderNumberList = this.orderNumber.split('\n');
        this.queryForm.params.orderWaybillNumberList = [];
      }
      weightRecordPage(this.queryForm).then(res => {
        if (res.code === 200) {
          this.total = res.data.total;

          const fieldsToConvert = ['transportWeight', 'weight', 'receiveVolumeWeight', 'volumeWeight', 'volume'];
          this.tableDate = res.data.records.map(item => {
            const newItem = { ...item };
            fieldsToConvert.forEach(field => {
              if (newItem[field]) {
                newItem[field] = this.formatSmallNumber(newItem[field]);
              }
            });
            return newItem;
          });
        }
      });
    },
    formatSmallNumber(num) {
      if (typeof num !== 'number') return num;

      const str = num.toString();
      if (str.includes('e')) {
        const decimalStr = num.toFixed(10);
        return decimalStr.replace(/\.?0+$/, '');
      }
      return str;
    },

    batchSelect(selection) {
      this.exportList = selection.map(item => {
        return item.waybillId;
      });
    },
    chooseDownload() {
      if (this.exportList.length <= 0) {
        // '请勾选要导出的数据'
        this.$message.warning(this.$t('collectionCenter.PleaseTickTheDataExport'));
        return;
      }
      const form = {
        cargoOrderIds: this.exportList
      };
      weightRecordExport(form).then(res => {
        if (res.code === 200) {
          this.exportList = [];
          this.$refs.tableRef.clearSelection();
          goRWExportList(this);
        }
      });
    },
    downloadAll() {
      if (this.tableDate.length <= 0) {
        // '无可导出数据'
        this.$message.warning(this.$t('collectionCenter.noDataExport'));
        return;
      }
      weightRecordAllExport(this.queryForm.params).then(res => {
        if (res.code === 200) {
          goRWExportList(this);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.orderNumClass ::v-deep .el-input__inner {
  font-size: 14px;
  color: #606266;
  font-weight: 700;
}
.selectClass ::v-deep .el-form-item {
  margin-right: 10px;
}
.Box{
  padding: 20px;
  box-sizing: border-box;
}
.right{
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
</style>
